/**
 * @fileoverview Respostas rápidas: quem vê as respostas cadastradas. O cadastro
 * delas continua no menu "Respostas rápidas".
 */

import React from "react";

import SettingsSection from "../../../components/Settings/SettingsSection";
import SettingItem from "../../../components/Settings/SettingItem";
import { i18n } from "../../../translate/i18n";
import { bindSetting } from "../useSettingsArea";

const t = (key) => i18n.t(`settings.sections.quick-replies.fields.quickMessagesScope.${key}`);

const QuickReplies = ({ area }) => (
  <SettingsSection>
    <SettingItem
      {...bindSetting(area, "quickMessagesScope", "user")}
      title={t("title")}
      description={t("description")}
      options={[
        { value: "user", label: t("options.user") },
        { value: "company", label: t("options.company") },
      ]}
    />
  </SettingsSection>
);

export default QuickReplies;
